import React from 'react';
import moment from 'moment';
import { merge, sumBy } from 'lodash';
import { decorateData } from '../common/OrderUtil';
import Loading from '../loading';
import {
  columnDataForStatement,
  columnDataForStatementReturns,
  valueFormat,
  monthes,
} from '../common/constants';
import { getStatements } from '../../api';
import { transferToCSV, currentDateForStatement } from '../common/OrderUtil';
import Summarization from './Summarization';
import EnhancedTableToolbar from './StatementTableToolbar';
import AlertDialog from '../common/AlertDialog';

const { formatMoney } = require('accounting');

class Statements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
      result: props.result
        ? props.result
        : {
            orders: { data: [] },
            returns: { data: [] },
            metadata: {
              year: currentDateForStatement().year(),
              month: currentDateForStatement().month(),
            },
            summary: {
              items: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
              },
              shippingCost: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
              },
              orders: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
              },
              returns: {
                orderQty: 0,
                itemQty: 0,
                totalCost: 0,
                shippingCost: {
                  totalCost: 0.0,
                },
              },
            },
          },
      filters: {
        year: currentDateForStatement().year(),
        month: currentDateForStatement().month(),
      },
      pageInfo: {
        pageSize: 20, // Defaults to 20 if not specified
        page: 0,
        order: 'asc',
        orderBy: 'created_at',
      },
    };
  }

  componentWillMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({ isFetching: true }, () =>
      // getStatements(merge(this.state.filters, this.state.pageInfo)).then(result => {
      getStatements(this.state.filters).then(result => {
        if (result && result.errors && result.errors.length > 0) {
          this.setState({ errors: result.errors, isFetching: false });
        } else {
          if (!result.data) {
            this.setState({
              errors: [{ message: 'The statement for the period selected is not available' }],
              isFetching: false,
            });
          }
          const currencies = {};
          const retultValues = {
            orders: { data: decorateData(result.data ? result.data.orders : []) },
            returns: { data: decorateData(result.data ? result.data.returns : []) },
            currency: '',
            subscriptionFee: result.data && result.data.subscriptionFee ? Number(result.data.subscriptionFee) : 0,
          };
          retultValues.summary = {
            items: {
              itemQty: 0,
              totalCost: 0.0,
            },
            shippingCost: {
              totalCost: 0.0,
            },
            orders: {
              orderQty: retultValues.orders.data.length,
              totalCost: 0,
            },
            returns: {
              orderQty: retultValues.returns.data.length,
              itemQty: 0,
              totalCost: 0.0,
              shippingCost: {
                totalCost: 0.0,
              },
            },
          };
          // add orders summarize
          retultValues.orders.data.forEach(shipmentOrder => {
            retultValues.summary.orders.totalCost += shipmentOrder.totalCostIncludeReturnWithoutGst;
            retultValues.summary.items.totalCost +=
              shipmentOrder.totalCostIncludeReturnWithoutShippingCostWithoutGst;
            retultValues.summary.shippingCost.totalCost += shipmentOrder.shippingCostWithoutGst;

            shipmentOrder.products.forEach(product => {
              currencies[product.currency.toUpperCase()] = 1;
              retultValues.summary.items.itemQty += product.quantityIncludeReturn;
            });
          });
          // add returns summary
          retultValues.returns.data.forEach(shipmentOrder => {
            retultValues.summary.returns.shippingCost.totalCost +=
              shipmentOrder.notAllReturnedShippingCostWithoutGst;
            retultValues.summary.returns.totalCost +=
              shipmentOrder.returnTotalCostWithoutShippingCostWithoutGst;
            shipmentOrder.products.forEach(product => {
              currencies[product.currency.toUpperCase()] = 1;
              retultValues.summary.returns.itemQty += product.returnQuantity;
            });
          });
          retultValues.currency = Object.keys(currencies);

          // Check the quantity of currencies in current report
          if (currencies && retultValues.currency.length > 1) {
            this.setState({
              errors: [
                {
                  message: `There are more than 1 currencies in the statement, they are ${retultValues.currency.toString()}`,
                },
              ],
              isFetching: false,
            });
          }
          retultValues.currency = retultValues.currency.toString();
          this.setState({ result: retultValues, isFetching: false });
        }
      })
    );
  };

  handleFilter = filtersObj => {
    const filters = this.state.filters;
    if (filtersObj) {
      Object.keys(filtersObj).forEach(key => {
        filters[key] = filtersObj[key];
        // filter blank filter
        if (filters[key] === '') {
          delete filters[key];
        }
      });
    }

    const pageInfo = this.state.pageInfo;
    pageInfo.page = 0;
    this.setState({ filters, pageInfo });
    this.doFilter();
  };

  handleChangePage = page => {
    const pageInfo = this.state.pageInfo;
    pageInfo.page = page;
    this.setState({ pageInfo });
    this.loadData();
  };

  handleChangePageSize = value => {
    const pageInfo = this.state.pageInfo;
    pageInfo.pageSize = value;
    pageInfo.page = 0;
    this.setState({ pageInfo });
    this.loadData();
  };

  doExport = type => {
    const fileName = `Statements-${type}(${this.state.filters.year} - ${
      monthes[this.state.filters.month]
    }).csv`;

    this.setState({ isFetching: true }, () => {
      let dataForExport = null;
      let columns = null;
      if (type === 'Orders') {
        dataForExport = this.state.result.orders.data;
        columns = columnDataForStatement;
      } else {
        dataForExport = this.state.result.returns.data;
        columns = columnDataForStatementReturns;
      }
      const data = dataForExport.map(order =>
        columns.map(item => {
          if (order[item.id] && typeof order[item.id] === 'object') {
            if (item.id === 'productShowNameWithoutBarCode') {
              return order[item.id].map(value => valueFormat(item, value)).join('.\n');
            }
            return order[item.id].map(value => valueFormat(item, value)).join('\n');
            // return order[item.id].join(String.fromCharCode(10));
          }
          return valueFormat(item, order[item.id]);
        })
      );
      data.unshift(columns.map(item => item.label));
      const csvFile = transferToCSV(data);
      const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
    this.setState({ isFetching: false });
  };

  doFilter = () => {
    this.loadData();
  };

  handleCloseAlert = type => {
    this.setState({ errors: null });
  };

  render() {
    const { result, pageInfo, errors, filters, isFetching } = this.state;
    const parameters =
      errors && errors.length > 0
        ? {
            title: 'Errors',
            message: errors.map(error => error.message),
            okButtonName: 'OK',
            handleClose: this.handleCloseAlert,
          }
        : {};

    return (
      <div style={{ marginTop: '50px' }}>
        <EnhancedTableToolbar
          handleFilter={this.handleFilter}
          doRest={this.doRest}
          filters={filters}
          doExport={this.doExport}
          result={result}
        />

        <Summarization
          summaries={[
            {
              label: 'Items',
              values: [
                {
                  label: 'Quantity',
                  value: `${result.summary.items.itemQty}`,
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.items.totalCost),
                },
              ],
            },
            {
              label: 'Shipping Cost',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.shippingCost.totalCost),
                },
              ],
            },
            {
              label: 'Orders Total',
              values: [
                {
                  label: 'Quantity',
                  value: `${result.summary.orders.orderQty}`,
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.orders.totalCost),
                  style: {
                    fontWeight: 'bold',
                  },
                },
              ],
            },
            {
              label: 'Credit Shipping Cost (*)',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: ' Cost (GST excluded)',
                  value: formatMoney(result.summary.returns.shippingCost.totalCost),
                },
              ],
            },
            {
              label: 'Credit Items (*)',
              values: [
                {
                  label: 'Quantity',
                  value: result.summary.returns.itemQty,
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.summary.returns.totalCost),
                },
              ],
            },
            {
              label: 'Subscription Fee',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(result.subscriptionFee),
                },
              ],
            },
            {
              label: 'Total:',
              values: [
                {
                  label: 'Quantity',
                  value: '',
                },
                {
                  label: 'Total Cost (GST excluded)',
                  value: formatMoney(
                    result.summary.orders.totalCost -
                      result.summary.returns.totalCost -
                      result.summary.returns.shippingCost.totalCost -
                      result.subscriptionFee
                  ),
                  style: {
                    background: '#789afd',
                    color: 'white',
                    fontWeight: 'bold',
                  },
                },
              ],
            },
          ]}
          withOutToolBar
          result={result}
          filters={filters}
          pageInfo={this.state.pageInfo}
          handleChangePage={this.handleChangePage}
          handleChangePageSize={this.handleChangePageSize}
        />
        <Loading show={this.state.isFetching} text="Loading..." />
        {errors && errors.length > 0 && <AlertDialog parameters={parameters} />}
      </div>
    );
  }
}

export default Statements;



// WEBPACK FOOTER //
// ./src/components/statements/index.js